export default "__VITE_ASSET__bfa8bd53__"